import { useStaticQuery, graphql } from "gatsby"

export const useSiteMetadata = () => {
  const { siteConfig } = useStaticQuery(graphql`
    query SiteConfigLayout {
      siteConfig {
        topLinks: Footer_Links {
          Link
          URL
        }
        columnLinks: footer_columns {
          name
          link
          links {
            name
            url
          }
        }
        resourceLinks: footer_horizontal {
          Link
          URL
        }
        copyrightLinks: footer_copyright_links {
          Link
          URL
        }
        copyright
        cta_link
        cta_link_signup
        google_sign_up
      }
    }
  `)

  const metadata = {
    footerLinks: {
      top: siteConfig.topLinks,
      columns: siteConfig.columnLinks,
      copyright: siteConfig.copyrightLinks,
      resources: siteConfig.resourceLinks,
    },
    copyright: siteConfig.copyright,
    ctaLink: siteConfig.cta_link,
    ctaLinkSignup: siteConfig.cta_link_signup,
    googleSignUp: siteConfig.google_sign_up,
    siteUrl: "https://www.klipfolio.com", // Retrieve this instead
  }

  return metadata
}
